<template>
    <div
        :class="isMobile ? 'my-2' : 'my-0'"
        style="display: inline-block;"
    >
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div v-on="on" class="timer-time">
                    <v-hover v-slot:default="{ hover }">
                        <div
                            class="tabular-nums"
                            :class="[
                                'time-disp text-right px-2 transition-ease-in-out',
                                timerTime > 0 ? 'n5--text' : 'n4--text'
                            ]"
                            style="border-radius: 8px"
                            :style="hover ? 'background-color: rgba(107,120,140,0.08)' : ''"
                            @click="$emit('manageTimeEntries')"
                        >
                            {{ isTaskRunning ? activeTimer : timerTime | format_time_duration }}
                        </div>
                    </v-hover>
                </div>
            </template>
            {{ $t('Open timesheet') }}
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn
                    icon
                    v-on="on"
                    :class="[
                        'ml-3',
                        isTaskRunning ? 'timer-btn-running' : 'timer-btn-paused'
                    ]"
                    :loading="startLoading"
                    @click="toggleStarted"
                >
                    <v-icon>{{ isTaskRunning ? "pause" : "mdi-play" }}</v-icon>
                </v-btn>
            </template>
            {{ isTaskRunning ? $t("Pause timer") : $t("Start timer") }}
        </v-tooltip>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn
                    icon
                    :class="[
                        'ml-3',
                        taskStatus !== 'finished'
                            ? 'timer-btn-not-done'
                            : 'timer-btn-done'
                    ]"
                    v-on="on"
                    :loading="completeLoading"
                    test-id="task-toggle-completed"
                    @click="$emit('toggleCompleted')"
                >
                    <v-icon>check</v-icon>
                </v-btn>
            </template>
            {{ taskStatus !== 'finished' ? $t("Mark done") : $t('Mark undone') }}
        </v-tooltip>
    </div>
</template>

<script>
import { ref, computed, watch, onMounted } from "@vue/composition-api";
import TaskModule from "../../store/modules/task";
import TimerModule from "../../store/modules/timer";

export default {
    name: "TaskTimerControl",
    props: {
        isMobile: {
            type: Boolean,
            required: true
        },
        timerTime: {
            type: Number,
            required: true
        },
        isTaskRunning: {
            type: Boolean,
            required: true
        },
        taskStatus: {
            type: String,
            required: true
        },
        startLoading: {
            type: Boolean,
            required: true
        },
        completeLoading: {
            type: Boolean,
            required: true
        },
    },
    setup(props, ctx) {
        const { current_task } = TaskModule();
        const timerModule = TimerModule();

        const activeTimer = computed(() => {
            if (!props.isTaskRunning) return;
            return (
                timerModule.total_duration.value +
                timerModule.running_duration.value +
                timerModule.ticking_duration.value
            );
        });

        function toggleStarted() {
            ctx.emit("toggleStarted");
        }
        return {
            current_task,
            toggleStarted,
            activeTimer
        };
    }
};
</script>
